import { ReactNode, createContext, useContext, useState } from 'react'
import { Dimensions, View } from 'react-native'

const WindowContext = createContext<number>(Dimensions.get('window').height)

type WindowProviderProps = {
  children: ReactNode
}

export const ActualHeightProvider = ({ children }: WindowProviderProps) => {
  const [appHeight, setAppHeight] = useState(Dimensions.get('window').height)
  return (
    <WindowContext.Provider value={appHeight}>
      <View style={{ flex: 1 }} onLayout={(e) => setAppHeight(e.nativeEvent.layout.height)}>
        {children}
      </View>
    </WindowContext.Provider>
  )
}

export const useActualHeight = () => {
  return useContext(WindowContext)
}
